import { SVGProps } from 'react'

export const Close = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line x1="0.707107" y1="1.29289" x2="13.435" y2="14.0208" stroke="#8D8D8D" strokeWidth="2" />
      <line
        y1="-1"
        x2="18"
        y2="-1"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 14.1426 2)"
        stroke="#8D8D8D"
        strokeWidth="2"
      />
    </svg>
  )
}
